import {
    Accordion,
    AccordionContent,
    AccordionItem,
    AccordionTrigger,
} from "@/components/ui/accordion";

const FAQS = [
    {
        q: "What is Build Bout?",
        a: "Build Bout is a co-working incubator for builders in Nakuru, Kenya. We bring developers, designers, and founders into the same room to build, ship, and demo projects together — with accountability.",
    },
    {
        q: "How can I join?",
        a: "Hit the 'Register for Event' button, fill in a short form, and we’ll invite you to the next cohort or build session. We prioritise people who actively ship.",
    },
    {
        q: "What is Build Bout's goal?",
        a: "To grow a generation of rural Kenyan builders who consistently ship real products. We measure success in deployed demos, not attendance.",
    },
    {
        q: "What's in it for us?",
        a: "A focused space, a peer group that ships, regular hackathons, feedback loops on your projects, and a network that extends beyond Nakuru.",
    },
    {
        q: "What amenities does Build Bout offer?",
        a: "A dedicated co-working environment, reliable power and internet, whiteboards, presentation gear, and — crucially — the right kind of peer pressure.",
    },
    {
        q: "What makes Build Bout different from other co-working groups?",
        a: "Most groups collect members. We collect finished projects. Our three habits — Build Together, Roll Out Together, Demonstrate — are non-negotiable.",
    },
];

export default function FAQ() {
    return (
        <section
            id="faq"
            data-testid="faq-section"
            className="relative py-20 md:py-32 bg-white"
        >
            <div className="mx-auto max-w-[1100px] px-6 md:px-10 lg:px-16">
                <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 md:gap-16">
                    <div className="lg:col-span-4">
                        <div className="inline-flex items-center gap-2 text-xs font-mono uppercase tracking-[0.2em] text-zinc-500 mb-5">
                            <span className="h-px w-8 bg-zinc-400" />
                            Questions
                        </div>
                        <h2 className="font-display text-4xl sm:text-5xl md:text-6xl font-black tracking-[-0.03em] text-zinc-950 leading-[0.95]">
                            Everything you need to know.
                        </h2>
                        <p className="mt-5 text-zinc-600 leading-relaxed">
                            Still curious? Reach out on Twitter or drop us an
                            email — we read everything.
                        </p>
                    </div>
                    <div className="lg:col-span-8">
                        <Accordion
                            type="single"
                            collapsible
                            defaultValue="item-0"
                            className="w-full"
                        >
                            {FAQS.map((item, i) => (
                                <AccordionItem
                                    key={i}
                                    value={`item-${i}`}
                                    data-testid={`faq-item-${i}`}
                                    className="border-b border-black/10"
                                >
                                    <AccordionTrigger className="py-6 text-left font-display text-xl md:text-2xl font-semibold tracking-tight text-zinc-950 hover:no-underline">
                                        {item.q}
                                    </AccordionTrigger>
                                    <AccordionContent className="pb-6 text-base text-zinc-600 leading-relaxed">
                                        {item.a}
                                    </AccordionContent>
                                </AccordionItem>
                            ))}
                        </Accordion>
                    </div>
                </div>
            </div>
        </section>
    );
}
